<template>
    <div id="logs">
        <v-list-item>
            <v-list-item-content>{{ log.db_muid }}</v-list-item-content>
            <v-list-item-content @click="openEmailBody()">{{ log.original_muid }}</v-list-item-content>
            <v-list-item-content>{{ $utils.mdy_format(log.email_date) }}</v-list-item-content>
            <v-list-item-content>{{ log.mimtype }}</v-list-item-content>
            <v-list-item-content>{{ log.s3_content_length }}</v-list-item-content>
            <v-list-item-content>{{ log.status === 1 ? 'Success' : 'Failure' }}</v-list-item-content>
            <v-list-item-content>{{ log.status_code }}</v-list-item-content>
        </v-list-item>
    </div>
</template>

<script>
export default {
    name: 'Logs',
    props: [
        'log'
    ],
    methods: {
        openEmailBody: function() {
            var view = this
            window.open(
                view.$url('RENDER_HTML') + view.log.db_muid,
                'emailbodypopup',
                'width=500,height=500'
            )
            window.focus()
        }
    }
}
</script>

<style lang="sass" scoped>
@import "./../assets/sass/logs.sass"
</style>